<script>
    import GPDetails from "./gp-details.svelte";
    import {getGPTransFunc} from "./gp-translations.js";
    let trans = getGPTransFunc("gp-itemdetails");

    export let type;
    let inside;

    let name;
    let bigimgsrc;

    export async function open() {
        if (type.model3d) {
            bigimgsrc = await type.staticGetPathForImage();
        } else {
            bigimgsrc = type.staticGetPathForImage();
            let parts = bigimgsrc.split('\\');
            bigimgsrc = parts.join('\\\\');
        }

        inside.open();
    }

</script>

<GPDetails type="{type}" bind:this={inside}>
    <div class="thumbarea">
        <div class="thumb" style="background-image: url({bigimgsrc});"/>
    </div>
</GPDetails>